module.exports = __webpack_public_path__ + "img/logo_head.36531631.svg";